import { DesignToken, RadiusToken, ShadowToken } from "@livechat/design-system-react-components";

import { IViewContainerTheme } from "interfaces/viewContainerTheme";

import { withVar } from "./helpers";

/**
 * @deprecated
 */
export const legacyTheme: IViewContainerTheme = {
  mobileBreakpoint: "705px",
  defaultFont: "'Source Sans Pro',-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica Neue,Arial,sans-serif",
  backgroundColor: withVar(DesignToken.SurfacePrimaryDefault),
  headerBackgroundColor: withVar(DesignToken.SurfacePrimaryDefault),
  headerColor: withVar(DesignToken.ContentBasicPrimary),
  primaryColor: withVar(DesignToken.ContentBasicPrimary),
  primaryColor30: withVar(DesignToken.BorderBasicPrimary),
  primaryColor50: withVar(DesignToken.ContentBasicDisabled),
  primaryColor60: withVar(DesignToken.ContentBasicSecondary),
  primaryColor80: withVar(DesignToken.ContentBasicSecondary),
  primaryGray: withVar(DesignToken.ContentBasicSecondary),
  secondaryGray: withVar(DesignToken.SurfaceTertiaryDefault),
  borderColor: withVar(DesignToken.BorderBasicSecondary),
  borderColorHover: withVar(DesignToken.BorderBasicHover),
  borderRadius: withVar(RadiusToken.Radius3),
  activeBorderColor: withVar(DesignToken.ActionPrimaryDefault),
  activeBoxShadow: withVar(ShadowToken.Float),
  linkColor: withVar(DesignToken.ActionPrimaryDefault),
  successColor: withVar(DesignToken.ActionPositiveDefault),
  warningColor: withVar(DesignToken.ActionNegativeDefault),
  errorColor: withVar(DesignToken.ActionNegativeDefault),
  errorColorLight: withVar(DesignToken.SurfaceAccentEmphasisLowNegative),
  button: {
    focus: {
      outline: {
        boxShadow: `0 0 1px 2px ${withVar(DesignToken.DecorBlue300)}`,
      },
    },
  },
  list: {
    hover: {
      backgroundColor: withVar(DesignToken.SurfaceSecondaryHover),
    },
    selected: {
      backgroundColor: withVar(DesignToken.SurfaceSecondaryActive),
    },
  },
  dropdown: {
    hover: {
      backgroundColor: withVar(DesignToken.PickerListGroupBackground),
      color: withVar(DesignToken.ContentBasicPrimary),
    },
    disabled: {
      color: withVar(DesignToken.ContentBasicDisabled),
    },
  },
  input: {
    backgroundColorTransition: "background-color 0.2s ease",
    borderColor: withVar(DesignToken.BorderBasicPrimary),
    focused: withVar(DesignToken.ActionPrimaryDefault),
    color: withVar(DesignToken.ContentBasicPrimary),
  },
  loader: {
    lightColor: withVar(DesignToken.SurfaceAccentEmphasisLowInfo),
    darkColor: withVar(DesignToken.SurfaceAccentEmphasisHighInfo),
  },
  selectBox: {
    head: {
      border: {
        color: withVar(DesignToken.BorderBasicPrimary),
        width: "1px",
        style: "solid",
        radius: withVar(RadiusToken.Radius3),
      },
      backgroundColor: withVar(DesignToken.SurfacePrimaryDefault),
    },
    body: {
      border: {
        color: "transparent",
        width: "0",
        style: "solid",
        radius: withVar(RadiusToken.Radius3),
      },
      backgroundColor: withVar(DesignToken.SurfacePrimaryDefault),
      boxShadow: withVar(ShadowToken.PopOver),
    },
  },
  columnPadding: "16px",
  configurator: {
    item: {
      border: {
        color: "transparent",
        width: "0",
        style: "solid",
        radius: withVar(RadiusToken.Radius3),
      },
      backgroundColor: withVar(DesignToken.SurfaceSecondaryDefault),
    },
  },
  filters: {
    title: {
      color: withVar(DesignToken.ContentBasicPrimary),
    },
    icon: {
      color: withVar(DesignToken.ContentBasicPrimary),
    },
    box: {
      border: {
        color: "transparent",
        width: "0",
        style: "solid",
        radius: withVar(RadiusToken.Radius3),
      },
      backgroundColor: withVar(DesignToken.SurfacePrimaryDefault),
      boxShadow: withVar(ShadowToken.PopOver),
    },
    submit: {
      default: {
        backgroundColor: withVar(DesignToken.ActionPrimaryDefault),
        color: withVar(DesignToken.ContentInvertPrimary),
        opacity: 0.8,
        border: {
          color: "transparent",
          width: "0",
          style: "solid",
          radius: withVar(RadiusToken.Radius3),
        },
      },
      hover: {
        backgroundColor: withVar(DesignToken.ActionPrimaryHover),
        color: withVar(DesignToken.ContentInvertPrimary),
        opacity: 1,
        border: {
          color: "transparent",
          width: "0",
          style: "solid",
          radius: withVar(RadiusToken.Radius3),
        },
      },
      disabled: {
        backgroundColor: withVar(DesignToken.SurfaceTertiaryDefault),
        color: withVar(DesignToken.ContentBasicPrimary),
        opacity: 0.8,
        border: {
          color: "transparent",
          width: "0",
          style: "solid",
          radius: withVar(RadiusToken.Radius3),
        },
      },
    },
  },
  table: {
    highlightedRow: {
      backgroundColor: withVar(DesignToken.SurfaceSecondaryDefault),
    },
  },
  tagBadge: {
    backgroundColor: withVar(DesignToken.SurfaceAccentEmphasisLowWarning),
    color: withVar(DesignToken.ContentBasicWarning),
    removeButton: {
      opacity: 1,
      color: withVar(DesignToken.ContentBasicWarning),
    },
  },
  textarea: {
    placeholderColor: withVar(DesignToken.ContentBasicDisabled),
  },
  checkbox: {
    backgroundColor: withVar(DesignToken.SurfacePrimaryDefault),
    borderColor: withVar(DesignToken.BorderBasicPrimary),
    checked: {
      borderColor: withVar(DesignToken.ActionPrimaryDefault),
      backgroundColor: withVar(DesignToken.ActionPrimaryDefault),
    },
    disabled: {
      borderColor: withVar(DesignToken.BorderBasicDisabled),
      backgroundColor: withVar(DesignToken.SurfacePrimaryDisabled),
    },
  },
  mobileSwipe: {
    cancelButton: {
      background: withVar(DesignToken.SurfaceTertiaryDefault),
      color: withVar(DesignToken.ContentBasicPrimary),
    },
  },
  messagebox: {
    border: {
      color: withVar(DesignToken.BorderBasicPrimary),
      radius: withVar(RadiusToken.Radius3),
    },
  },
  liteWarning: {
    backgroundColor: withVar(DesignToken.SurfaceAccentEmphasisLowWarning),
    borderColor: "transparent",
  },
  notificationsBar: {
    warning: withVar(DesignToken.SurfaceAccentEmphasisHighWarning),
    info: withVar(DesignToken.SurfaceAccentEmphasisHighInfo),
  },
};
